import index from "./auditCompanyInvoiceBox.vue";
export default index;
